import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import MediaInfoComponent from '../../../../../common/components/common/media-info.component';
import IncludeComponent from '../../../../../common/components/common/include.component';
import ExcludeComponent from '../../../../../common/components/common/exclude.component';
import OrderPolicyValuesComponent from './order-policies-info.component';
import OrderPolicyBasicInfoComponent from './order-policy-basic-info.component';




export const OrderPolicyComponent = ({entityTypes,selectedOrderPolicyValues,handleFormOrderPolicyItemChange,customers,products,allTags,categories,onInnerFormChange,id,fileTypes,mediaFiles,handleFormMediaItemChange, changeImage,selectedOrderPolicys,onInnerBasicFormChange,back,handleFormSubmit}: any) => {

  const tabItems=[
    {
        id:1,
        title:'Basic-Info',
        component:(
          <OrderPolicyBasicInfoComponent
                    
                      onInnerBasicFormChange={onInnerBasicFormChange}
                      selectedOrderPolicys={selectedOrderPolicys}
                      entityTypes={entityTypes}
                    />
        ),
    isVisible:true,
    },
    {
      id:2,
      title:'Include Entity',
      component: <IncludeComponent
      allTags={allTags}
      isSaleChannel={true}
      isCustomerTag={true}
      isCustomer={true}
      isStore={true}
      isWarehouse={true}
      isState={true}
      isCountry={true}
      customers={customers}
      handleInnerFormChange={onInnerFormChange}
      selectedInclude= {selectedOrderPolicys}
    />,
  isVisible:true,
  },

  {
    id:3,
    title:'Exclude Entity',
    component:<ExcludeComponent
    isSaleChannel={true}
      isCustomerTag={true}
      isCustomer={true}
      isStore={true}
      isWarehouse={true}
      isState={true}
      isCountry={true}
  allTags={allTags} 
  customers={customers}
  handleInnerFormChange={onInnerFormChange}
    selectedExclude ={selectedOrderPolicys}
  />,
isVisible:true,
},
// {
//   id:4,
//   title:'Media',
//       component: 
//     <MediaInfoComponent
//                 changeImage={changeImage}
//                // deleteSelectedProduct={deleteSelectedCategory}
//                 fileTypes={fileTypes}
//                 //handleClose={handleClose}
//                 //handleOpen={handleOpen}
//                 onFormItemChange={handleFormMediaItemChange}
//                // openConfirmation={openConfirmation}
//                 mediaFiles={mediaFiles}
//                 //uploadToDigiiFolder={uploadToDigiiFolder}
//                 />,
//     isVisible:id > 0 ? true : false,
//     },
    {
      id:4,
      title:'Order',
          component: 
        <OrderPolicyValuesComponent
        selectedOrderPolicys={selectedOrderPolicys}
        onFormOrderPolicyItemChange={handleFormOrderPolicyItemChange}
                   selectedOrderPolicyValues={selectedOrderPolicyValues}
                   categories={categories}
                   products={products}
                   
                    />,
        isVisible:true,
        },
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default OrderPolicyComponent;
